import { pluralizePerMinute } from "~/utils/pluralize";
import formatPrice from "~/utils/formatPrice";

const getTariffText = ({ price, duration, name, code }) =>
  `${name || code} - (${pluralizePerMinute(duration)}) - ${formatPrice(price)}`;

export default getTariffText;
